import type { DropResult } from 'react-beautiful-dnd';
import type { EControlSettingType } from '../../type';
import type { IControlSettingUI } from '../types';

import { useControlSettingStore } from '../../ReportFilter/stores/control-setting';
import { DragDropContext, Draggable } from 'react-beautiful-dnd';
import { GStrictModeDroppable } from '~/presentation/common';
import { Control } from './Control';
import { useState } from 'react';

interface ChildrenControlProps {
  data: IControlSettingUI;
  type: EControlSettingType;
}

export const ChildrenControl = ({ data, type }: ChildrenControlProps) => {
  const isHasChildren = data.controls && data.controls.length > 0;

  const [isDragging, setIsDragging] = useState(false);

  const reorderControlChild = useControlSettingStore((state) => state.reorderControlChild);

  if (!isHasChildren) return null;

  if (data.controls?.length === 1) {
    return data.controls?.map((child) => <Control key={child.id} data={child} type={type} />);
  }

  const handleDragEnd = (result: DropResult) => {
    setIsDragging(false);

    if (!result.destination) return;

    reorderControlChild(
      {
        parent: data,
        uid: result.draggableId,
        newIndex: result.destination.index,
      },
      type,
    );
  };

  return (
    <DragDropContext
      onDragEnd={handleDragEnd}
      onDragStart={() => {
        setIsDragging(true);
      }}
    >
      <GStrictModeDroppable droppableId="control-list">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {data.controls?.map((child, index) => {
              if (!child.uid) return <Control key={child.id} data={child} type={type} />;

              return (
                <Draggable key={child.uid} draggableId={child.uid} index={index}>
                  {(provided, snapshot) => {
                    return (
                      <Control
                        key={child.uid}
                        data={{ ...child, draggable: { provided, snapshot, isDragging } }}
                        type={type}
                      />
                    );
                  }}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </GStrictModeDroppable>
    </DragDropContext>
  );
};
